import { ResourceType } from '../../enumerations/ResourceType';
import { ParentedArtifactResource } from '../artifactResourceTypes';
import {
    AddOrSetMutateObjectWithParentRelation,
    AddOrSetMutateObjectWithParentRelationSchema,
    BatchAddMutateObjectWithRelation,
    BatchAddMutateObjectWithRelationSchema,
} from '../mutateObjects';
import { PersistableSchemaType } from '../persistableResourceTypes';
import { useMutationWithDelay } from '../useMutationWithDelay';
import { useMultiResourceMultiParentedResourceAdapterBaseActions } from './useMultiResourceMultiParentedResourceAdapterBaseActions';

export function useMultiResourceMultiParentedResourceAdapterActions<R extends ParentedArtifactResource>(
    apiPostfix: string,
    resourceType: ResourceType,
    resourceSchema: PersistableSchemaType<R>
) {
    const actions = useMultiResourceMultiParentedResourceAdapterBaseActions(apiPostfix, resourceType, resourceSchema);

    const useAddResource = () => {
        return useMutationWithDelay(
            (mutateObject: AddOrSetMutateObjectWithParentRelation<R>) =>
                actions.addOrSetResource(mutateObject.resource, mutateObject.parentId as string, mutateObject.parentRelation),
            AddOrSetMutateObjectWithParentRelationSchema
        );
    };

    const useBatchAddResource = () => {
        return useMutationWithDelay(
            (mutateObject: BatchAddMutateObjectWithRelation<R>) =>
                actions.batchAddResourceWithParentRelation(mutateObject.payload, mutateObject.parentRelation),
            BatchAddMutateObjectWithRelationSchema
        );
    };

    return {
        useValidateResource: actions.useValidateResource,
        useValidateAllResourcesMultiParented: actions.useValidateAllResourcesMultiParented,
        useGetResource: actions.useGetResource,
        getParentRelationText: actions.getParentRelationText,
        useUpdateResource: actions.useUpdateResource,
        useDeleteResource: actions.useDeleteResource,
        useGetAllResources: actions.useGetAllResources,
        processMutationResponse: actions.processMutationResponse,
        processGetResponse: actions.processGetResponse,
        processGetCollectionResponse: actions.processGetCollectionResponse,
        processGetResourceResponse: actions.processGetResourceResponse,
        useAddResource,
        useBatchAddResource,
    };
}
